import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { ArrowSmallRight, VyIcon } from '@vy/ui-design-system';
import { useMenu } from '../../../../../hooks/use-menu';

type AddToInvoiceMenuProps = {
  handleOpenAddPoDialog: (event: React.MouseEvent<HTMLElement>) => void;
  handleOpenAddDescriptionDialog: (event: React.MouseEvent<HTMLElement>) => void;
};

export const AddToInvoiceMenu: React.FC<AddToInvoiceMenuProps> = ({
  handleOpenAddPoDialog,
  handleOpenAddDescriptionDialog,
}) => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();

  return (
    <>
      <MenuItem onClick={handleMenuOpen}>
        <ListItemIcon>
          <VyIcon
            icon="PlusMedium"
            color="black"
            style={{
              transform: 'scale(0.7)',
            }}
          />
        </ListItemIcon>

        <ListItemText>Add to invoice</ListItemText>

        <ArrowSmallRight />
      </MenuItem>

      <Menu
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleOpenAddPoDialog}>
          <ListItemText>Add PO</ListItemText>
        </MenuItem>

        <MenuItem onClick={handleOpenAddDescriptionDialog}>
          <ListItemText>Add details</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
